import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromPayment from '../_reducers/payment';

export const selectPaymentState = createFeatureSelector<fromPayment.PaymentState>('payments');

export const selectAllPayments = createSelector(selectPaymentState, fromPayment.selectAll);

export const selectPaymentEntities = createSelector(selectPaymentState, fromPayment.selectEntities);

export const selectPaymentById = (id: number) =>
  createSelector(selectPaymentEntities, (entities) => entities[id]);

export const selectPaymentTotal = createSelector(selectPaymentState, fromPayment.selectTotal);
